import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { distinctUntilChanged } from 'rxjs/operators';
import { resolveDataLoadState } from '@/common/dataState';

reframe.registerSub('sub::recently-visited.events', () =>
    reframe
        .indexPath(['recently-visited', 'events'], Immutable.OrderedMap())
        .pipe(distinctUntilChanged(Immutable.is, a => a.keySeq()))
);

reframe.regSub(
    'sub::recently-visited.events.ids',
    () => [reframe.subscribe(['sub::recently-visited.events'])],
    ([events]) => events.keySeq()
);

reframe.regSub('sub::recently-visited.events.event', (db, [_, eventId]) =>
    db.getIn(['recently-visited', 'events', eventId])
);

reframe.regSub(
    'sub::recently-visited.data-state',
    () => [reframe.subscribe(['sub::recently-visited.events'])],
    ([events]) => resolveDataLoadState(events)
);
